import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import { Header } from '../Header';
import { Footer } from '../Footer';

export default class FM extends Base {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            loading: true,
            path: [],
            record: null,
            popup: 0,
            newName: '',
            allDirectories: [],
            file: null
        };
    }
    uploadLargFile(selectedFile) {
        var path = this.state.path;
        var root = "";
        path.forEach(p => root += "/" + p);
        return new Promise((resolve, reject) => {
            const chunkSize = 1 * 1024 * 1024; // 1MB (adjust based on your requirements)
            const totalChunks = Math.ceil(selectedFile.size / chunkSize);
            const chunkProgress = 100 / totalChunks;
            let chunkNumber = 0;
            let start = 0;
            let end = 0;
            const uploadNextChunk = async () => {
                if (chunkNumber <= totalChunks) {
                    if (end == 0) {
                        if (selectedFile.size >= chunkSize) end = chunkSize;
                        else end = selectedFile.size;
                    }
                    if (end > selectedFile.size) end = selectedFile.size;

                    const chunk = selectedFile.slice(start, end);
                    const formData = new FormData();
                    
                    formData.append("root", root);
                    formData.append("file", chunk);
                    formData.append("chunkNumber", chunkNumber);
                    formData.append("totalChunks", totalChunks);
                    formData.append("originalname", selectedFile.name);

                    fetch("/api/v1/filemanager/upload_chunk", {
                        method: "POST",
                        body: formData,
                    })
                    .then((response) => response.json())
                    .then((data) => {
                        if (data.status == 0) {
                            this.showErorrMessage(data.message);
                            resolve({ status: false });
                            return;
                        }
                        if (data.status == -1) {
                            window.location.href = "/login";
                            return;
                        }
                        if (data.status == 2) {
                        }
                        var percent = Number((chunkNumber + 1) * chunkProgress);
                        document.getElementById("progressBar").style.width = percent + "%";
                        document.getElementById("progressBar2").innerHTML = Math.round(percent) + "% آپلود شده";
                        chunkNumber++;
                        start = end;
                        end = start + chunkSize;
                        uploadNextChunk();
                    })
                    .catch((error) => {
                        this.showErorrMessage("ارسال فایل ویدئو با خطا مواجه شد. لطفا مجدد ارسال نمایید.");
                        resolve({ status: false });
                    });
                } else {
                    document.getElementById("progressBar").style.width = "0%";
                    document.getElementById("progressBar2").innerHTML = "0% آپلود شده";
                    resolve({ status: true });
                }
            };

            uploadNextChunk();
        })
    }
    async doUpload() {
        var resualt = await this.uploadLargFile(this.state.file);
        if (!resualt.status) {
            this.showErorrMessage("ارسال فایل انجام نپذیرفت");
            this.closePopup();
            this.getList();
            return;
        }
        this.showSuccessMessage("عملیات با موفقیت انجام شد");
        this.closePopup();
        this.getList();
    }
    setFile(file) {
        this.state.file = file;
        this.setState({ file: file });
        this.doUpload();
    }
    componentDidMount() {
        this.getList();
    }
    getList() {
        this.httpPost("api/v1/filemanager/list", {
            path: this.state.path
        })
        .then(data => {
            if (data.status === -1) window.location.href = "/login";
            if (data.status === 1) {
                this.setState({
                    data: data,
                    loading: false
                })
            }
            else {
                this.showErorrMessage(data.message);
                this.setState({
                    loading: false
                });
            }
        });
    }
    doRemove() {
        this.httpPost("api/v1/filemanager/remove", {
            path: this.state.record.fullPath,
            isFile: this.state.record.isFile,
        })
        .then(data => {
            if (data.status === -1) window.location.href = "/login";
            if (data.status === 1) {
                this.showSuccessMessage("عملیات با موفقیت انجام شد");
                this.closePopup();
                this.getList();
            }
            else {
                this.showErorrMessage(data.message);
                this.setState({
                    loading: false
                });
            }
        });
    }
    doCopy(distination) {
        this.httpPost("api/v1/filemanager/copy", {
            path: this.state.record.fullPath,
            isFile: this.state.record.isFile,
            distination
        })
        .then(data => {
            if (data.status === -1) window.location.href = "/login";
            if (data.status === 1) {
                this.showSuccessMessage("عملیات با موفقیت انجام شد");
                this.closePopup();
                this.getList();
            }
            else {
                this.showErorrMessage(data.message);
                this.setState({
                    loading: false
                });
            }
        });
    }
    doMove(distination) {
        this.httpPost("api/v1/filemanager/move", {
            path: this.state.record.fullPath,
            isFile: this.state.record.isFile,
            distination
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("عملیات با موفقیت انجام شد");
                    this.closePopup();
                    this.getList();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    doRename() {
        this.httpPost("api/v1/filemanager/rename", {
            path: this.state.record.fullPath,
            isFile: this.state.record.isFile,
            newName: this.state.newName,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("عملیات با موفقیت انجام شد");
                    this.closePopup();
                    this.getList();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    doNewFolder() {
        this.httpPost("api/v1/filemanager/newfolder", {
            path: this.state.path,
            newName: this.state.newName,
        })
        .then(data => {
            if (data.status === -1) window.location.href = "/login";
            if (data.status === 1) {
                this.showSuccessMessage("عملیات با موفقیت انجام شد");
                this.closePopup();
                this.getList();
            }
            else {
                this.showErorrMessage(data.message);
                this.setState({
                    loading: false
                });
            }
        });
    }
    showDetail(record) {
        this.setState({ popup: 1, record: record });
    }
    copy(record) {
        this.httpPost("api/v1/filemanager/listall", {
            path: this.state.path
        })
        .then(data => {
            if (data.status === -1) window.location.href = "/login";
            if (data.status === 1) {
                this.setState({ popup: 2, record: record, loading: false, allDirectories: data.records  });
            }
            else {
                this.showErorrMessage(data.message);
                this.setState({
                    loading: false
                });
            }
        });
    }
    move(record) {
        this.httpPost("api/v1/filemanager/listall", {
            path: this.state.path
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({ popup: 3, record: record, loading: false, allDirectories: data.records });
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    remove(record) {
        this.setState({ popup: 4, record: record });
    }
    newFolder() {
        this.setState({ popup: 5, newName:'New Folder' });
    }
    uploadFile() {
        this.setState({ popup: 6 });
    }
    rename(record) {
        this.setState({ newName: record.name, popup: 7, record: record });
    }
    clickFolder(record) {
        if (!record.isFile) {
            this.state.path.push(record.name);
            this.getList();
        }
    }
    back(index) {
        var t = [];
        for (var i = 0; i <= index; i++)
            t.push(this.state.path[i]);
        this.state.path = t;
        this.setState({ path: t });
        this.getList()
    }
    renderDetail() {
        return <div className="modal fade show" tabindex="-1" role="dialog" id="file-details" aria-modal="true" style={{ "display": "block", "padding-left": "0px" }}>
            <div className="modal-dialog modal-md" role="document">
                <div className="modal-content">
                    <div className="modal-header align-center">
                        <div className="nk-file-title">
                            <div className="nk-file-name">
                                <div className="nk-file-name-text"><span className="title">{this.state.record.name }</span></div>
                            </div>
                        </div>
                        <a onClick={e => this.closePopup()} className="close hand"><em className="icon ni ni-cross-sm"></em></a>
                    </div>
                    <div className="modal-body">
                        <div className="nk-file-details">
                            <div className="nk-file-details-row">
                                <div className="nk-file-details-col">نوع</div>
                                <div className="nk-file-details-col">{this.state.record.isFile ? "فایل" : "فولدر" }</div>
                            </div>
                            <div className="nk-file-details-row">
                                <div className="nk-file-details-col">اندازه</div>
                                <div className="nk-file-details-col">{this.showSize(this.state.record) }</div>
                            </div>
                            <div className="nk-file-details-row">
                                <div className="nk-file-details-col">Location</div>
                                <div className="nk-file-details-col">
                                    <ul className="breadcrumb breadcrumb-sm breadcrumb-alt breadcrumb-arrow">
                                        {this.state.record.fullPath.map(r => <li className="breadcrumb-item">{r}</li>)}
                                    </ul>
                                </div>
                            </div>
                            <div className="nk-file-details-row">
                                <div className="nk-file-details-col">ایجاد</div>
                                <div className="nk-file-details-col">{this.state.record.createDate }</div>
                            </div>
                            <div className="nk-file-details-row">
                                <div className="nk-file-details-col">آخرین تغییر</div>
                                <div className="nk-file-details-col">{this.state.record.lastAccessDate}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    renderCopy() {
        return <div className="modal fade show" tabindex="-1" id="file-copy" style={{ "display": "block" }} aria-modal="true" role="dialog">
            <div className="modal-dialog modal-md" role="document">
                <div className="modal-content">
                    <div className="modal-header align-center border-bottom-0">
                        <h5 className="modal-title">کپی</h5>
                        <a className="close hand" onClick={e => this.closePopup()}><em className="icon ni ni-cross-sm"></em></a>
                    </div>
                    <div className="modal-body pt-0 mt-n2">
                        <ul className="breadcrumb breadcrumb-alt breadcrumb-xs breadcrumb-arrow mb-1">
                            {this.state.record.fullPath.map(r => <li className="breadcrumb-item">{r}</li>)}
                            <li className="breadcrumb-item">{this.state.record.name}</li>
                        </ul>
                        <div className="nk-fmg-listing is-scrollable">
                            <div className="nk-files nk-files-view-list is-compact">
                                <div className="nk-files-list">
                                    {this.state.allDirectories.map(d =>
                                        <div className="nk-file-item nk-file">
                                            <div className="nk-file-info">
                                                <a className="nk-file-link">
                                                    <div className="nk-file-title">
                                                        <div className="nk-file-icon">
                                                            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 72 72">
                                                                <path fill="#6C87FE" d="M57.5,31h-23c-1.4,0-2.5-1.1-2.5-2.5v-10c0-1.4,1.1-2.5,2.5-2.5h23c1.4,0,2.5,1.1,2.5,2.5v10 C60,29.9,58.9,31,57.5,31z"></path>
                                                                <path fill="#8AA3FF" d="M59.8,61H12.2C8.8,61,6,58,6,54.4V17.6C6,14,8.8,11,12.2,11h18.5c1.7,0,3.3,1,4.1,2.6L38,24h21.8 c3.4,0,6.2,2.4,6.2,6v24.4C66,58,63.2,61,59.8,61z"></path>
                                                                <path display="none" fill="#8AA3FF" d="M62.1,61H9.9C7.8,61,6,59.2,6,57c0,0,0-31.5,0-42c0-2.2,1.8-4,3.9-4h19.3 c1.6,0,3.2,0.2,3.9,2.3l2.7,6.8c0.5,1.1,1.6,1.9,2.8,1.9h23.5c2.2,0,3.9,1.8,3.9,4v31C66,59.2,64.2,61,62.1,61z"></path>
                                                                <path fill="#798BFF" d="M7.7,59c2.2,2.4,4.7,2,6.3,2h45c1.1,0,3.2,0.1,5.3-2H7.7z"></path>
                                                            </svg>
                                                        </div>
                                                        <div className="nk-file-name">
                                                            <div className="nk-file-name-text">
                                                                <span className="title">{d}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </a>
                                            </div>
                                            <div className="nk-file-actions">
                                                <a onClick={e => this.doCopy(d)} className="hand btn btn-sm btn-icon btn-trigger">کپی</a>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    renderMove() {
        return <div className="modal fade show" tabindex="-1" id="file-copy" style={{ "display": "block" }} aria-modal="true" role="dialog">
            <div className="modal-dialog modal-md" role="document">
                <div className="modal-content">
                    <div className="modal-header align-center border-bottom-0">
                        <h5 className="modal-title">انتقال</h5>
                        <a className="close hand" onClick={e => this.closePopup()}><em className="icon ni ni-cross-sm"></em></a>
                    </div>
                    <div className="modal-body pt-0 mt-n2">
                        <ul className="breadcrumb breadcrumb-alt breadcrumb-xs breadcrumb-arrow mb-1">
                            {this.state.record.fullPath.map(r => <li className="breadcrumb-item">{r}</li>)}
                            <li className="breadcrumb-item">{this.state.record.name}</li>
                        </ul>
                        <div className="nk-fmg-listing is-scrollable">
                            <div className="nk-files nk-files-view-list is-compact">
                                <div className="nk-files-list">
                                    {this.state.allDirectories.map(d =>
                                        <div className="nk-file-item nk-file">
                                            <div className="nk-file-info">
                                                <a className="nk-file-link">
                                                    <div className="nk-file-title">
                                                        <div className="nk-file-icon">
                                                            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 72 72">
                                                                <path fill="#6C87FE" d="M57.5,31h-23c-1.4,0-2.5-1.1-2.5-2.5v-10c0-1.4,1.1-2.5,2.5-2.5h23c1.4,0,2.5,1.1,2.5,2.5v10 C60,29.9,58.9,31,57.5,31z"></path>
                                                                <path fill="#8AA3FF" d="M59.8,61H12.2C8.8,61,6,58,6,54.4V17.6C6,14,8.8,11,12.2,11h18.5c1.7,0,3.3,1,4.1,2.6L38,24h21.8 c3.4,0,6.2,2.4,6.2,6v24.4C66,58,63.2,61,59.8,61z"></path>
                                                                <path display="none" fill="#8AA3FF" d="M62.1,61H9.9C7.8,61,6,59.2,6,57c0,0,0-31.5,0-42c0-2.2,1.8-4,3.9-4h19.3 c1.6,0,3.2,0.2,3.9,2.3l2.7,6.8c0.5,1.1,1.6,1.9,2.8,1.9h23.5c2.2,0,3.9,1.8,3.9,4v31C66,59.2,64.2,61,62.1,61z"></path>
                                                                <path fill="#798BFF" d="M7.7,59c2.2,2.4,4.7,2,6.3,2h45c1.1,0,3.2,0.1,5.3-2H7.7z"></path>
                                                            </svg>
                                                        </div>
                                                        <div className="nk-file-name">
                                                            <div className="nk-file-name-text">
                                                                <span className="title">{d}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </a>
                                            </div>
                                            <div className="nk-file-actions">
                                                <a onClick={e => this.doMove(d)} className="hand btn btn-sm btn-icon btn-trigger">انتقال</a>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    renderRemove() {
        return <div className="modal fade show" tabindex="-1" style={{ "display": "block" }} aria-modal="true" role="dialog">
            <div className="modal-dialog modal-md" role="document">
                <div className="modal-content">
                    <div className="modal-header align-center border-bottom-0">
                        <h5 className="modal-title">حذف</h5>
                        <a onClick={e => this.closePopup()} className="hand close"><em className="icon ni ni-cross-sm"></em></a>
                    </div>
                    <div className="modal-body pt-0 mt-n2">
                        <ul className="breadcrumb breadcrumb-alt breadcrumb-xs breadcrumb-arrow mb-1">
                            {this.state.record.fullPath.map(r => <li className="breadcrumb-item">{r}</li>)}
                        </ul>
                        <div className="nk-fmg-listing is-scrollable">
                            <div className="nk-files nk-files-view-list is-compact">
                            <p>آیا با حذف اطلاعات موافق هستید</p>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer modal-footer-stretch  bg-light">
                        <div className="modal-footer-between">
                            <div className="g">
                                <li><a onClick={e => this.closePopup()} className="hand link link-primary">برگشت</a></li>
                            </div>
                            <div className="g">
                                <ul className="btn-toolbar g-3">
                                    <li><a onClick={ e=>this.doRemove() } className="hand btn btn-danger">حذف</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    renderRename() {
        return <div className="modal fade show" tabindex="-1" style={{ "display": "block" }} aria-modal="true" role="dialog">
            <div className="modal-dialog modal-md" role="document">
                <div className="modal-content">
                    <div className="modal-header align-center border-bottom-0">
                        <h5 className="modal-title">تغییر نام</h5>
                        <a onClick={e => this.closePopup()} className="hand close"><em className="icon ni ni-cross-sm"></em></a>
                    </div>
                    <div className="modal-body pt-0 mt-n2">
                        <ul className="breadcrumb breadcrumb-alt breadcrumb-xs breadcrumb-arrow mb-1">
                            {this.state.record.fullPath.map(r => <li className="breadcrumb-item">{r}</li>)}
                        </ul>
                        <div className="nk-fmg-listing is-scrollable">
                            <div className="nk-files nk-files-view-list is-compact">
                                <p>نام جدیدی وارد نمایید</p>
                                <input type="text" className="form-control ltr" placeholder="عنوان جدید" defaultValue={this.state.newName} onChange={e=>this.state.newName = e.target.value} />
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer modal-footer-stretch  bg-light">
                        <div className="modal-footer-between">
                            <div className="g">
                                <li><a onClick={e => this.closePopup()} className="hand link link-primary">برگشت</a></li>
                            </div>
                            <div className="g">
                                <ul className="btn-toolbar g-3">
                                    <li><a onClick={e => this.doRename()} className="hand btn btn-primary">تغییر نام</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    renderUploadFile() {
        return <div className="modal fade show" tabindex="-1" role="dialog" id="file-upload" aria-modal="true" style={{ "display": "block", " padding-left": "0px" }} >
            <div className="modal-dialog modal-md" role="document">
                <div className="modal-content">
                    <a onClick={e => this.closePopup()} className="hand close"><em className="icon ni ni-cross-sm"></em></a>
                    <div className="modal-body modal-body-md">
                        <div className="nk-upload-form">
                            <h5 className="title mb-3">آپلود فایل</h5>
                            <div className="upload-zone small bg-lighter dropzone dz-clickable">
                                <div className="dz-message" data-dz-message="">
                                    <span className="dz-message-text"><span>فایل مورد نظر را انتخاب نمایید</span></span>
                                    <input type="file" onChange={(e) => { this.setFile(e.target.files[0]) }} />
                                </div>
                            </div>
                        </div>
                        {this.state.file != null && <div className="nk-upload-list">
                            <div className="nk-upload-item">
                                <div className="nk-upload-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 72">
                                        <g>
                                            <path d="M50,61H22a6,6,0,0,1-6-6V22l9-11H50a6,6,0,0,1,6,6V55A6,6,0,0,1,50,61Z" style={{ "fill": "#599def" }}></path>
                                            <path d="M25,20.556A1.444,1.444,0,0,1,23.556,22H16l9-11h0Z" style={{ "fill": "#c2e1ff" }}></path>
                                            <rect x="27" y="31" width="18" height="2" rx="1" ry="1" style={{ "fill": "#fff" }}></rect>
                                            <rect x="27" y="36" width="18" height="2" rx="1" ry="1" style={{ "fill": "#fff" }}></rect>
                                            <rect x="27" y="41" width="18" height="2" rx="1" ry="1" style={{ "fill": "#fff" }}></rect>
                                            <rect x="27" y="46" width="12" height="2" rx="1" ry="1" style={{ "fill": "#fff" }}></rect>
                                        </g>
                                    </svg>
                                </div>
                                <div className="nk-upload-info">
                                    <div className="nk-upload-title"><span className="title">لطفا تا اپلود تمام فایل صبر نمایید</span> <span className="meta" id="progressBar2">0% آپلود شده</span></div>
                                    <div className="nk-upload-progress">
                                        <div className="progress progress-sm">
                                            <div className="progress-bar" id="progressBar" style={{ "width": "0%" }}></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>}
                    </div>
                </div>
            </div>
        </div>
    }
    renderNewFolder() {
        return <div className="modal fade show" tabindex="-1" style={{ "display": "block" }} aria-modal="true" role="dialog">
            <div className="modal-dialog modal-md" role="document">
                <div className="modal-content">
                    <div className="modal-header align-center border-bottom-0">
                        <h5 className="modal-title">ایجاد فولدر جدید</h5>
                        <a onClick={e => this.closePopup()} className="hand close"><em className="icon ni ni-cross-sm"></em></a>
                    </div>
                    <div className="modal-body pt-0 mt-n2">
                        <div className="nk-fmg-listing is-scrollable">
                            <div className="nk-files nk-files-view-list is-compact">
                                <p>نام فولدر جدید را وارد نمایید</p>
                                <input type="text" className="form-control ltr" placeholder="عنوان فولدر جدید" defaultValue={this.state.newName} onChange={e => this.state.newName = e.target.value} />
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer modal-footer-stretch  bg-light">
                        <div className="modal-footer-between">
                            <div className="g">
                                <li><a onClick={e => this.closePopup()} className="hand link link-primary">برگشت</a></li>
                            </div>
                            <div className="g">
                                <ul className="btn-toolbar g-3">
                                    <li><a onClick={e => this.doNewFolder()} className="hand btn btn-primary">ایجاد فولدر</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    closePopup() {
        this.setState({ popup: 0, newName: '', record: null,file: null });
    }
    getRecordType(record) {
        if (!record.isFile){
            return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 72">
                        <g>
                            <rect x="32" y="16" width="28" height="15" rx="2.5" ry="2.5" style={{ "fill":"#f29611"}} />
        <path d="M59.7778,61H12.2222A6.4215,6.4215,0,0,1,6,54.3962V17.6038A6.4215,6.4215,0,0,1,12.2222,11H30.6977a4.6714,4.6714,0,0,1,4.1128,2.5644L38,24H59.7778A5.91,5.91,0,0,1,66,30V54.3962A6.4215,6.4215,0,0,1,59.7778,61Z" style={{"fill":"#ffb32c"}} />
                            <path d="M8.015,59c2.169,2.3827,4.6976,2.0161,6.195,2H58.7806a6.2768,6.2768,0,0,0,5.2061-2Z" style={{"fill":"#f2a222"}} />
                        </g>
                    </svg>
        }
        if (record.extension == "xls" || record.extension == "xlsx"){
            return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 72">
                        <path d="M49,61H23a5.0147,5.0147,0,0,1-5-5V16a5.0147,5.0147,0,0,1,5-5H40.9091L54,22.1111V56A5.0147,5.0147,0,0,1,49,61Z" style={{"fill":"#e3edfc"}} />
                        <path d="M54,22.1111H44.1818a3.3034,3.3034,0,0,1-3.2727-3.3333V11s1.8409.2083,6.9545,4.5833C52.8409,20.0972,54,22.1111,54,22.1111Z" style={{"fill":"#b7d0ea"}} />
                        <path d="M19.03,59A4.9835,4.9835,0,0,0,23,61H49a4.9835,4.9835,0,0,0,3.97-2Z" style={{"fill":"#c4dbf2"}} />
                        <path d="M42,31H30a3.0033,3.0033,0,0,0-3,3V45a3.0033,3.0033,0,0,0,3,3H42a3.0033,3.0033,0,0,0,3-3V34A3.0033,3.0033,0,0,0,42,31ZM29,38h6v3H29Zm8,0h6v3H37Zm6-4v2H37V33h5A1.001,1.001,0,0,1,43,34ZM30,33h5v3H29V34A1.001,1.001,0,0,1,30,33ZM29,45V43h6v3H30A1.001,1.001,0,0,1,29,45Zm13,1H37V43h6v2A1.001,1.001,0,0,1,42,46Z" style={{"fill":"#36c684"}} />
                    </svg>
        }
        if (record.extension == "zip"){
            return  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 72">
                        <g>
                            <rect x="18" y="16" width="36" height="40" rx="5" ry="5" style={{"fill":"#e3edfc"}} />
                            <path d="M19.03,54A4.9835,4.9835,0,0,0,23,56H49a4.9835,4.9835,0,0,0,3.97-2Z" style={{"fill":"#c4dbf2"}} />
        <rect x="32" y="20" width="8" height="2" rx="1" ry="1" style={{"fill":"#7e95c4"}} />
                            <rect x="32" y="25" width="8" height="2" rx="1" ry="1" style={{"fill":"#7e95c4"}} />
                            <rect x="32" y="30" width="8" height="2" rx="1" ry="1" style={{"fill":"#7e95c4"}} />
                            <rect x="32" y="35" width="8" height="2" rx="1" ry="1" style={{"fill":"#7e95c4"}} />
                            <path d="M35,16.0594h2a0,0,0,0,1,0,0V41a1,1,0,0,1-1,1h0a1,1,0,0,1-1-1V16.0594A0,0,0,0,1,35,16.0594Z" style={{"fill":"#7e95c4"}} />
                            <path d="M38.0024,40H33.9976A1.9976,1.9976,0,0,0,32,41.9976v2.0047A1.9976,1.9976,0,0,0,33.9976,46h4.0047A1.9976,1.9976,0,0,0,40,44.0024V41.9976A1.9976,1.9976,0,0,0,38.0024,40Zm-.0053,4H34V42h4Z" style={{"fill":"#7e95c4"}} />
                        </g>
                    </svg>
                    }
                    
        if (record.extension == "doc" || record.extension == "docx"){
                   return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 72">
                        <g>
        <path d="M49,61H23a5.0147,5.0147,0,0,1-5-5V16a5.0147,5.0147,0,0,1,5-5H40.9091L54,22.1111V56A5.0147,5.0147,0,0,1,49,61Z" style={{"fill":"#e3edfc"}} />
        <path d="M54,22.1111H44.1818a3.3034,3.3034,0,0,1-3.2727-3.3333V11s1.8409.2083,6.9545,4.5833C52.8409,20.0972,54,22.1111,54,22.1111Z" style={{"fill":"#b7d0ea"}} />
                            <path d="M19.03,59A4.9835,4.9835,0,0,0,23,61H49a4.9835,4.9835,0,0,0,3.97-2Z" style={{"fill":"#c4dbf2"}} />
        <rect x="27" y="31" width="18" height="2" rx="1" ry="1" style={{"fill":"#599def"}} />
                            <rect x="27" y="36" width="18" height="2" rx="1" ry="1" style={{"fill":"#599def"}} />
                            <rect x="27" y="41" width="18" height="2" rx="1" ry="1" style={{"fill":"#599def"}} />
                            <rect x="27" y="46" width="12" height="2" rx="1" ry="1" style={{"fill":"#599def"}} />
                        </g>
                    </svg>
                    }
        if (record.extension == "gif" || record.extension == "png" || record.extension == "webp" || record.extension == "jpg" || record.extension == "jpeg" || record.extension == "tif"){
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 72">
                        <path d="M49,61H23a5.0147,5.0147,0,0,1-5-5V16a5.0147,5.0147,0,0,1,5-5H40.9091L54,22.1111V56A5.0147,5.0147,0,0,1,49,61Z" style={{"fill":"#e3edfc"}} />
                        <path d="M54,22.1111H44.1818a3.3034,3.3034,0,0,1-3.2727-3.3333V11s1.8409.2083,6.9545,4.5833C52.8409,20.0972,54,22.1111,54,22.1111Z" style={{"fill":"#b7d0ea"}} />
    <path d="M19.03,59A4.9835,4.9835,0,0,0,23,61H49a4.9835,4.9835,0,0,0,3.97-2Z" style={{"fill":"#c4dbf2"}} />
    <path d="M27.2223,43H44.7086s2.325-.2815.7357-1.897l-5.6034-5.4985s-1.5115-1.7913-3.3357.7933L33.56,40.4707a.6887.6887,0,0,1-1.0186.0486l-1.9-1.6393s-1.3291-1.5866-2.4758,0c-.6561.9079-2.0261,2.8489-2.0261,2.8489S25.4268,43,27.2223,43Z" style={{ "fill":"#755de0"}} />
                    </svg>
                    }
        if (record.extension == "pdf"){
                    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 72">
                                <path d="M50,61H22a6,6,0,0,1-6-6V22l9-11H50a6,6,0,0,1,6,6V55A6,6,0,0,1,50,61Z" style={{"fill":"#f26b6b"}}></path>
                                <path d="M25,20.556A1.444,1.444,0,0,1,23.556,22H16l9-11h0Z" style={{"fill":"#f4c9c9"}}></path>
                                <path d="M46.3342,44.5381a4.326,4.326,0,0,0-2.5278-1.4289,22.436,22.436,0,0,0-4.5619-.3828A19.3561,19.3561,0,0,1,35.82,37.9536a56.5075,56.5075,0,0,0,1.3745-6.0858,2.339,2.339,0,0,0-.4613-1.8444,1.9429,1.9429,0,0,0-1.5162-.753h-.0014a1.6846,1.6846,0,0,0-1.3893.6966c-1.1493,1.5257-.3638,5.219-.1941,5.9457a12.6118,12.6118,0,0,0,.7236,2.1477,33.3221,33.3221,0,0,1-2.49,6.1052,20.3467,20.3467,0,0,0-5.9787,3.4413,2.5681,2.5681,0,0,0-.8861,1.8265,1.8025,1.8025,0,0,0,.6345,1.3056,2.0613,2.0613,0,0,0,1.3942.5313,2.2436,2.2436,0,0,0,1.4592-.5459,20.0678,20.0678,0,0,0,4.2893-5.3578,20.8384,20.8384,0,0,1,5.939-1.1858A33.75,33.75,0,0,0,42.96,47.7858,2.6392,2.6392,0,0,0,46.376,47.55,2.08,2.08,0,0,0,46.3342,44.5381ZM27.6194,49.6234a.8344.8344,0,0,1-1.0847.0413.4208.4208,0,0,1-.1666-.2695c-.0018-.0657.0271-.3147.4408-.736a18.0382,18.0382,0,0,1,3.7608-2.368A17.26,17.26,0,0,1,27.6194,49.6234ZM34.9023,30.848a.343.343,0,0,1,.3144-.1514.6008.6008,0,0,1,.4649.2389.853.853,0,0,1,.1683.6722v0c-.1638.92-.4235,2.381-.8523,4.1168-.0125-.05-.0249-.1-.037-.1506C34.6053,34.0508,34.3523,31.5779,34.9023,30.848ZM33.7231,43.5507a34.9732,34.9732,0,0,0,1.52-3.7664,21.2484,21.2484,0,0,0,2.2242,3.05A21.8571,21.8571,0,0,0,33.7231,43.5507Zm11.7054,2.97a1.3085,1.3085,0,0,1-1.6943.0887,33.2027,33.2027,0,0,1-3.0038-2.43,20.9677,20.9677,0,0,1,2.8346.3335,2.97,2.97,0,0,1,1.7406.9647C45.8377,46.1115,45.6013,46.3483,45.4285,46.5212Z" style={{"fill":"#fff"}}></path>
                            </svg>
                            }
        if (record.extension == "mov" || record.extension == "mp4" || record.extension == "3gp"){
                      return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 72">
                          <path d="M50,61H22a6,6,0,0,1-6-6V22l9-11H50a6,6,0,0,1,6,6V55A6,6,0,0,1,50,61Z" style={{"fill":"#f74141"}}></path>
                          <path d="M25,20.556A1.444,1.444,0,0,1,23.556,22H16l9-11h0Z" style={{"fill":"#ffa9a9"}}></path>
                                                            <path d="M46,46.5v-13A3.5042,3.5042,0,0,0,42.5,30h-13A3.5042,3.5042,0,0,0,26,33.5v13A3.5042,3.5042,0,0,0,29.5,50h13A3.5042,3.5042,0,0,0,46,46.5ZM40,45v3H37V45Zm-3-2V37h7v6Zm0-8V32h3v3Zm-2-3v3H32V32Zm0,5v6H28V37Zm0,8v3H32V45Zm7.5,3H42V45h2v1.5A1.5016,1.5016,0,0,1,42.5,48ZM44,33.5V35H42V32h.5A1.5016,1.5016,0,0,1,44,33.5ZM29.5,32H30v3H28V33.5A1.5016,1.5016,0,0,1,29.5,32ZM28,46.5V45h2v3h-.5A1.5016,1.5016,0,0,1,28,46.5Z" style={{"fill":"#fff"}}></path>
                                                        </svg>
                                                        }
        if (record.extension == "mp3" || record.extension == "wav"){
                      return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 72">
                                                            <path d="M50,61H22a6,6,0,0,1-6-6V22l9-11H50a6,6,0,0,1,6,6V55A6,6,0,0,1,50,61Z" style={{"fill":"#5a5aff"}}></path>
                                                            <path d="M25,20.556A1.444,1.444,0,0,1,23.556,22H16l9-11h0Z" style={{"fill":"#b8b8ff"}}></path>
                                                            <path d="M44.6465,30.2373a1.006,1.006,0,0,0-.811-.2236l-12,2A1,1,0,0,0,31,33v9.5563A3.9543,3.9543,0,0,0,29,42a4,4,0,1,0,4,4V33.8467l10-1.666v8.3757A3.9543,3.9543,0,0,0,41,40a4,4,0,1,0,4,4V31A.999.999,0,0,0,44.6465,30.2373ZM29,48a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,29,48Zm12-2a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,41,46Z" style={{"fill":"#f3f3f3"}}></path>
                                                        </svg>
                                                        }
        if (record.extension == "txt"){
                                                        return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 72">
                                                            <g>
                                                                <path d="M49,61H23a5.0147,5.0147,0,0,1-5-5V16a5.0147,5.0147,0,0,1,5-5H40.9091L54,22.1111V56A5.0147,5.0147,0,0,1,49,61Z" style={{"fill":"#e3edfc"}}></path>
                                                                <path d="M54,22.1111H44.1818a3.3034,3.3034,0,0,1-3.2727-3.3333V11s1.8409.2083,6.9545,4.5833C52.8409,20.0972,54,22.1111,54,22.1111Z" style={{"fill":"#b7d0ea"}}></path>
                                                                <path d="M19.03,59A4.9835,4.9835,0,0,0,23,61H49a4.9835,4.9835,0,0,0,3.97-2Z" style={{"fill":"#c4dbf2"}}></path>
                                                                <rect x="27" y="31" width="18" height="2" rx="1" ry="1" style={{"fill":"#599def"}}></rect>
                                                                <rect x="27" y="36" width="18" height="2" rx="1" ry="1" style={{"fill":"#599def"}}></rect>
                                                                <rect x="27" y="41" width="18" height="2" rx="1" ry="1" style={{"fill":"#599def"}}></rect>
                                                                <rect x="27" y="46" width="12" height="2" rx="1" ry="1" style={{"fill":"#599def"}}></rect>
                                                            </g>
                                                        </svg>
                                                        }
                                                        return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 72">
                                                            <g>
                                                                <path d="M49,61H23a5.0147,5.0147,0,0,1-5-5V16a5.0147,5.0147,0,0,1,5-5H40.9091L54,22.1111V56A5.0147,5.0147,0,0,1,49,61Z" style={{"fill":"#e3edfc"}}></path>
                                                                <path d="M54,22.1111H44.1818a3.3034,3.3034,0,0,1-3.2727-3.3333V11s1.8409.2083,6.9545,4.5833C52.8409,20.0972,54,22.1111,54,22.1111Z" style={{"fill":"#b7d0ea"}}></path>
                                                            </g>
                                                        </svg>
    }
    showSize(record) {
        if (!record.isFile) return "";

        var size = record.size;
        var byte = 1024;
        var kbyte = byte * 1000;
        var mbyte = kbyte * 1024;
        var gbyte = mbyte * 1024;

        if (size < byte) return size + " بایت";
        if (size < kbyte) return this.FixedPointNumber(size/byte,2) + " کیلوبایت";
        if (size < mbyte) return this.FixedPointNumber(size/kbyte, 2) + " مگابایت";
        if (size < gbyte) return this.FixedPointNumber(size/mbyte, 2) + " گیگابایت";

        return size + " بایت";
    }
    getPathToFile(record) {
        var t = "";
        record.fullPath.forEach((p, index) => {
            t += "/" + p;
        });
        if (t == "") t = "/";
        return t;
    }
    renderForm() {
        return <div className="nk-content-body">
            <div className="nk-fmg" style={{ "paddingRight": "0" }}>                                    
                                    <div className="nk-fmg-body">
                                        <div className="nk-fmg-body-head d-none d-lg-flex">
                                            <div className="nk-fmg-search">
                                            </div>
                                            <div className="nk-fmg-actions">
                                                <ul className="nk-block-tools g-3">
                                                    <li><a onClick={e => this.newFolder() } className="hand btn btn-info"><em className="icon ni ni-folder-plus"></em> <span>فولدر جدید</span></a></li>
                                                    <li><a onClick={e => this.uploadFile()} className="hand btn btn-primary"><em className="icon ni ni-upload-cloud"></em> <span>آپلود فایل</span></a></li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="nk-fmg-body-content">
                                            <div className="nk-fmg-listing nk-block-lg">
                                                <div className="tab-content">
                                                    <div className="tab-pane active" id="file-grid-view">
                                                        <div className="nk-files nk-files-view-grid">
                                                            <ul className="breadcrumb breadcrumb-sm breadcrumb-alt breadcrumb-arrow" style={{ "direction": "ltr" }}>
                                                                {this.state.path.length > 0 && <li className="breadcrumb-item hand" onClick={e => this.back(-1)}>...</li>}
                                                                {this.state.path.map((p,index)=>
                                                                    index < this.state.path.length - 1 ? <li className="breadcrumb-item hand" onClick={e => this.back(index)}>{p}</li>
                                                                        : <li className="breadcrumb-item">{p}</li>
                                                                )}
                                                            </ul>
                                                            <div className="nk-files-list">
                                                            {this.state.data.records.map(record=>
                                                                <div className="nk-file-item nk-file">
                                                                    <div className="nk-file-info">
                                                                        <div className="nk-file-title">
                                                                            <div className="nk-file-icon">
                                                                                <a className="nk-file-icon-link hand" onClick={e=>this.clickFolder(record)}>
                                                                                    <span className="nk-file-icon-type">
                                                                                        {this.getRecordType(record)}
                                                                                    </span>
                                                                                </a>
                                                                            </div>
                                                                            <div className="nk-file-name">
                                                                                <div className="nk-file-name-text">
                                                                                    <a className="title">{record.name}</a>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <ul className="nk-file-desc">
                                                                            <li className="date">{record.lastAccessDate}</li>
                                                                            <li className="size">{this.showSize(record)}</li>
                                                                        </ul>
                                                                    </div>
                                                                    <div className="nk-file-actions">
                                                                        <div className="dropdown">
                                                                            <a href="" className="dropdown-toggle btn btn-sm btn-icon btn-trigger" data-bs-toggle="dropdown"><em className="icon ni ni-more-h"></em></a>
                                                                            <div className="dropdown-menu dropdown-menu-end">
                                                                                <ul className="link-list-plain no-bdr">
                                                                                    <li><a onClick={e => this.showDetail(record) } className="hand"><em className="icon ni ni-eye"></em><span>جزئیات</span></a></li>
                                                                                    <li><a onClick={e => this.copy(record)} className="hand"><em className="icon ni ni-copy"></em><span>کپی</span></a></li>
                                                                                    <li><a onClick={e => this.move(record)} className="hand"><em className="icon ni ni-forward-arrow"></em><span>انتقال</span></a></li>
                                                                                    {record.isFile && <li><a href={"/api/v1/filemanager/download?path=" + this.getPathToFile(record) + "&name=" + record.name} target="_blank" className="file-dl-toast"><em className="icon ni ni-download"></em><span>دانلود</span></a></li>}
                                                                                    <li><a onClick={e => this.rename(record)} className="hand"><em className="icon ni ni-pen"></em><span>تغییر نام</span></a></li>
                                                                                    <li><a onClick={e => this.remove(record)} className="hand"><em className="icon ni ni-trash"></em><span>حذف</span></a></li>
                                                                                </ul>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                <div className="nk-content">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                this.state.popup === 1 && this.renderDetail(),
                this.state.popup === 2 && this.renderCopy(),
                this.state.popup === 3 && this.renderMove(),
                this.state.popup === 4 && this.renderRemove(),
                this.state.popup === 5 && this.renderNewFolder(),
                this.state.popup === 6 && this.renderUploadFile(),
                this.state.popup === 7 && this.renderRename(),
                <Footer />
            ];

        return contents;
    }
}